<template>
	<div>
		<a-spin :spinning="loading">
			<div class="flex space alcenter">
				<div class="ft20 cl-main ftw600">{{getTitle}}</div>
				<a-button @click="$router.go(-1)">返回</a-button>
			</div>
			
			<div class="mt20 bg-w pd40">
				<div>
					<a-form-model :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
						<a-form-model-item required label="角色名称">
							<a-input v-model="form.role_name"  :maxLength="100" placeholder="输入角色名称" style="width: 300px;"></a-input>
						</a-form-model-item>

						<a-form-model-item label="权限字符" help="英文/下划线/数字编号">
							<a-input v-model="form.role_key" :maxLength="30" placeholder="输入权限字符" style="width: 300px;"></a-input>
						</a-form-model-item>
						<a-form-model-item required label="排序">
							<a-input-number v-model="form.sort" :formatter="value => `${value}`" placeholder="请输入"  :min="0" style="width: 120px;"/>
						</a-form-model-item>

						<a-form-model-item required label="状态">
							<a-radio-group v-model="form.status.value" button-style="solid">
								<a-radio-button :value="1">
								正常
								</a-radio-button>
								<a-radio-button :value="0">
								停用
								</a-radio-button>
							</a-radio-group>
						</a-form-model-item>
						<a-form-model-item required label="应用">
							<a-select style="width: 300px;"
                                v-decorator="[
                                'gender',
                                { rules: [{ required: true, message: '应用项必选' }] },
                                ]"
                                placeholder="请选择应用"
								v-model="form.app_id"
                                @change="handleSelectChange"
                            >
								<a-select-option v-for="(item, idx) in appList" :key="item.id" :value="item.app_id">
									{{item.app_name}}（{{item.app.name}}）
								</a-select-option>
                            </a-select>
						</a-form-model-item>
						<a-form-model-item required label="菜单">
							<div style="border:1px solid #d6d6d6;">
								<a-directory-tree
									v-model="checkedKeys"
									checkable
									:expanded-keys="expandedKeys"
									:auto-expand-parent="autoExpandParent"
									:selected-keys="selectedKeys"
									:replaceFields="replaceFields"
									:showIcon="false"
									:tree-data="menuList"
									@expand="onExpand"
									@select="onSelect"
								/>
							</div>
						</a-form-model-item>

						<a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
							<a-button type="primary" @click="onSubmit" :loading="confirmLoading">
							确定保存
							</a-button>
						</a-form-model-item>
					</a-form-model>	
				</div>
			</div>
		</a-spin>
	</div>
</template>

<script>
	export default{
		data(){
			return {
				loading:false,
				confirmLoading:false,
				labelCol: { span: 4 },
				wrapperCol: { span: 20 },
				roleId: 0,
				menuList: [],
				appList: [],
				expandedKeys: [],
				autoExpandParent: false,
				checkedKeys: [],
				selectedKeys: [],
				replaceFields:{children:'children', title:'menu_name', key:'id'},
				form: {
					role_name: '',
					status: {text: '正常', value: 1},
					sort: 99,
					role_key: '',
				}
			}
		},
		computed:{
			getTitle(){
				if(this.roleId == 0){
					return "添加角色";
				}else{
					return "修改角色"
				}
			},

		},
		watch: {
			checkedKeys(val) {
				//console.log('onCheck', val);
			},
		},
		created() {
			this.getApp();
			if (!this.$route.query.id) {
				this.roleId=0;
			} else {
				this.roleId = parseInt(this.$route.query.id);
			}
			if (this.$route.query.app_id) {
				this.getAppMenu(this.$route.query.app_id);
			}
			this.init();
		},
		methods:{
			init(){
				if(this.loading==true) return;
				this.loading=true;
				this.$http.api('platform/account/role/detail',{
					role_id: this.roleId
				}).then(res=>{
					if(res.detail){
						this.form = res.detail;
						this.setCheckedKeys(res.detail.purview);
					}
					this.loading=false;
				}).catch(res=>{
					console.log(res);
					this.loading=false;
					this.$router.go(-1);
				})
			},
			getApp(){
				this.$http.api('platform/account/home').then(res=>{
					this.appList = res.appList;
					this.loading=false;
				}).catch(res=>{
					console.log(res);
					this.loading=false;
				})
			},
			getAppMenu(appId){
				this.$http.api('platform/account/role/getAppMenu',{
					app_id: appId,
				}).then(res=>{
					this.menuList = res.menus;
					this.loading=false;
				}).catch(res=>{
					console.log(res);
					this.loading=false;
				})
			},
			handleSelectChange(){
				this.getAppMenu(this.form.app_id);
			},
			onExpand(expandedKeys) {
				//console.log('onExpand', expandedKeys);
				this.expandedKeys = expandedKeys;
				this.autoExpandParent = false;
			},
			onCheck(checkedKeys) {
				this.checkedKeys = checkedKeys;
			},
			onSelect(selectedKeys, info) {
				//console.log('onSelect', info);
				//this.selectedKeys = selectedKeys;
			},
			setCheckedKeys(purview){
				if(purview.length > 0){
					let purviewArr = [];
					for(let key in purview){
						purviewArr.push(purview[key].menu_id);
					}
					this.checkedKeys = purviewArr;
				}
			},
			onSubmit() {
				if(this.form.role_name == ''){
					this.$message.error('请输入角色名称');
					return false;
				}
				if(this.form.sort == ''){
					this.$message.error('请输入排序');
					return false;
				}
				if(this.form.app_id == undefined){
					this.$message.error('请选择应用');
					return false;
				}
				if(this.checkedKeys.length == 0){
					this.$message.error('请选择菜单');
					return false;
				}
				if(this.confirmLoading==true) return;
				this.confirmLoading = true;
				this.$http.api('platform/account/role/add',{
					role_id: this.roleId,
					role_name: this.form.role_name,
					status: this.form.status.value,
					sort: this.form.sort,
					app_id: this.form.app_id,
					role_key: this.form.role_key,
					menu_ids: this.checkedKeys.join(',')
				}).then(res=>{
					this.$message.success('操作成功', 1, ()=>{
						this.confirmLoading=false;
						this.$router.go(-1);
					});
				}).catch(res=>{
					console.log(res);
					this.confirmLoading=false;
				})
			},
			
		}
	}
</script>

<style>
.ant-tree.ant-tree-directory .ant-tree-child-tree>li.ant-tree-treenode-selected>span.ant-tree-node-content-wrapper:before, .ant-tree.ant-tree-directory>li.ant-tree-treenode-selected>span.ant-tree-node-content-wrapper:before{
	background-color: #e6f7ff; color:rgba(0,0,0,.65);
}
.ant-tree.ant-tree-directory .ant-tree-child-tree>li span.ant-tree-node-content-wrapper.ant-tree-node-selected, .ant-tree.ant-tree-directory>li span.ant-tree-node-content-wrapper.ant-tree-node-selected{
	color:rgba(0,0,0,.65);
}
.ant-tree.ant-tree-directory .ant-tree-child-tree>li.ant-tree-treenode-selected>span.ant-tree-switcher, .ant-tree.ant-tree-directory>li.ant-tree-treenode-selected>span.ant-tree-switcher
{
	color:rgba(0,0,0,.65);
}
</style>